/**
 * EmployeeLimitWarning Component
 *
 * Displays a warning when the user has reached their employee limit.
 */

import React from "react";
import { Alert, Button, Group, Text } from "@mantine/core";
import { IconUsers } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { useFeatureAccess } from "../../context/FeatureAccessContext";

interface EmployeeLimitWarningProps {
  /** Whether to show the upgrade button (default: true) */
  showUpgradeButton?: boolean;
}

export const EmployeeLimitWarning: React.FC<EmployeeLimitWarningProps> = ({
  showUpgradeButton = true,
}) => {
  const navigate = useNavigate();
  const { access, canAddEmployee } = useFeatureAccess();

  // Don't show if can still add employees
  if (!access || canAddEmployee()) {
    return null;
  }

  return (
    <Alert color="orange" icon={<IconUsers size={20} />} variant="light">
      <Group justify="space-between" wrap="nowrap" gap="md">
        <Text size="sm">
          You've reached your employee limit ({access.max_allowed_employees}).
          {showUpgradeButton && " Upgrade your plan to add more team members."}
        </Text>
        {showUpgradeButton && (
          <Button
            variant="light"
            color="orange"
            size="xs"
            onClick={() => navigate("/admin/settings/subscription")}
          >
            Upgrade Plan
          </Button>
        )}
      </Group>
    </Alert>
  );
};

export default EmployeeLimitWarning;
